import type { HomeData } from '@blockbattle/shared';
import type { PathData } from './api.js';

export const isPathPlayerBarRoute = (pathname: string): boolean =>
  pathname === '/path' || pathname.startsWith('/path/');

export const hidesGlobalPlayerBar = (pathname: string): boolean =>
  pathname.startsWith('/game/') || pathname === '/tutorial';

export const pathPlayerBarData = (
  home: Pick<HomeData, 'user' | 'energy'>,
  path: Pick<PathData, 'progress'>,
): {
  readonly user: HomeData['user'];
  readonly energy: HomeData['energy'];
  readonly context: {
    readonly kind: 'PATH';
    readonly stars: number;
  };
} => ({
  user: { ...home.user, pathCoins: path.progress.softCurrency },
  energy: home.energy,
  context: {
    kind: 'PATH',
    stars: path.progress.totalStars,
  },
});
